import { keymap } from "prosemirror-keymap";
import { nodes as basicNodes } from "prosemirror-schema-basic";
import { Extension } from "../../core/extension";
import { bindCommandToKey, toggleBlockNode } from "../../commands/commands";
export class BlockquoteExtension extends Extension {
    addNodes(nodes) {
        const { blockquote } = basicNodes;
        return nodes.append({ blockquote });
    }
    addCommands(schema) {
        return {
            toggleBlockquote: toggleBlockNode(schema.nodes.blockquote),
        };
    }
    addPlugins(schema, plugins, { commands }) {
        return plugins.concat([
            keymap({
                "Ctrl->": bindCommandToKey(commands.toggleBlockquote),
            }),
        ]);
    }
}
